import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-status',
  templateUrl: './email-status.component.html',
  styleUrls: ['./email-status.component.scss'],
})
export class EmailStatusComponent {
  constructor(
    public dialogRef: MatDialogRef<EmailStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { successMessage: string },
  ) {}
}
